export enum TruncationMode {
  Start,
  Middle,
  End,
}
